export function getData(url,action){
  fetch(url)
  .then((response) => {
    if (response.status >= 400) {
      throw new Error("Bad response from server");
    }
    // console.log('r',response);
    return response.json();
  })
  .then((data) => {
    action(data);
  });
}